var map = {
	"./android-icon.svg": 2169,
	"./app-img.png": 2170,
	"./app-qr-code-bg.png": 2171,
	"./apple-icon.svg": 2172,
	"./contact-bg.png": 2173,
	"./contact-us-bg.jpg": 2174,
	"./contact-us-main-bg.webp": 2175,
	"./qr-bg.png": 2176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2168;